/* [ATLAS V41 10/24] Lot fit tool script, moved out of sections/atlas-lot-fit.liquid. */
(function () {
  var dataEl = document.getElementById('atl-lotfit-data');
  if (!dataEl) return;
  var plans = [];
  try { plans = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var root = document.querySelector('.atl-lf');
  var form = document.getElementById('atl-lf-form');
  var CLOSE = 3, MAXCMP = 3, RECENT_KEY = 'atl_lf_recent';
  var tab = 'fit';
  var DEFAULTS = { w: '', d: '', f: '25', r: '20', s: '7.5', ss: '15', t: 'all', o: 'best', fz: 'none', fd: 'any' };
  // [ATLAS V41 10/24] "basement" keeps its old meaning (walkout) so links shared before V41 still work; plain basement is "bsmt".
  var FD_NAMES = { slab: 'a slab', crawl: 'a crawlspace', pier: 'piers', piling: 'pilings', bsmt: 'a basement', basement: 'a walkout basement' };
  var FD_SHORT = { slab: 'Slab', crawl: 'Crawlspace', pier: 'Piers', piling: 'Pilings', bsmt: 'Basement', basement: 'Walkout basement' };
  var FZ_NAMES = { none: 'none or X', a: 'Zone A', v: 'Zone V' };
  var lot = null, searchTimer = null, lastSent = '', shareQuery = '', lastDraw = null, compare = [], site = null, lastFit = [], lastClose = [];
  // GA4 through the store's Google tag. Parameters registered in GA4 as custom definitions on Oct 22.
  function track(name, params) { try { if (typeof window.gtag === 'function') window.gtag('event', name, params); } catch (e) {} }

  plans.forEach(function (p) {
    var vals = Array.isArray(p.fo) && p.fo.length ? p.fo : String(p.fm || '').split('/');
    var f = { slab: false, crawl: false, pier: false, piling: false, bsmt: false, basement: false };
    var inc = [], extra = [];
    vals.forEach(function (raw) {
      var v = String(raw).toLowerCase();
      if (/slab/.test(v)) f.slab = true;
      if (/crawl/.test(v)) f.crawl = true;
      if (/pier/.test(v)) f.pier = true;
      if (/piling/.test(v)) f.piling = true;
      if (/walkout|daylight/.test(v)) f.basement = true; else if (/basement/.test(v)) f.bsmt = true;
      var label = String(raw).replace(/\s*\(\+[^)]*\)\s*$/, '').replace(/\s+foundation$/i, '').trim();
      if (!label) return;
      if (/\(\+/.test(raw)) extra.push(label); else inc.push(label);
    });
    p.fds = f; p.inc = inc; p.extra = extra;
    p.elev = /^elevated/i.test(p.el || '');
    p.adu = /garage|adu/i.test(p.pt || '');
  });
  document.getElementById('lf-catalog').textContent = plans.length + ' plans in the Intertwine catalog';
  // Foundation chips only for types at least one plan offers.
  form.querySelectorAll('input[name="fd"]').forEach(function (el) {
    if (el.value === 'any') return;
    var any = plans.some(function (p) { return p.fds[el.value]; });
    if (!any) el.closest('label').hidden = true;
  });
  function byHandle(h) { return plans.filter(function (p) { return p.h === h; })[0]; }

  var params = new URLSearchParams(location.search);
  var pickHandle = null;
  function setRadio(name, v) {
    var el = form.querySelector('input[name="' + name + '"][value="' + v + '"]');
    if (el) el.checked = true;
  }
  function applyParams(ps) {
    ['w', 'd', 'f', 'r', 's', 'ss', 't', 'o'].forEach(function (k) {
      if (ps.has(k) && form.elements[k]) form.elements[k].value = ps.get(k);
    });
    // [ATLAS V39 10/24] Old links may carry o=room, which no longer exists.
    if (!form.elements.o.value) form.elements.o.value = DEFAULTS.o;
    if (!form.elements.t.value) form.elements.t.value = DEFAULTS.t;
    setRadio('fz', ps.get('fz') || 'none');
    setRadio('fd', ps.get('fd') || 'any');
    form.elements.rot.checked = ps.get('rot') === '1';
    form.elements.c.checked = ps.get('c') === '1';
    pickHandle = ps.get('plan');
    if (pickHandle && !byHandle(pickHandle)) pickHandle = null;
    compare = (ps.get('cmp') || '').split(',').filter(function (h, i, a) { return h && byHandle(h) && a.indexOf(h) === i; }).slice(0, MAXCMP);
    syncCorner();
  }
  function syncCorner() {
    var wrap = form.querySelector('.lf-ss');
    if (wrap) wrap.hidden = !form.elements.c.checked;
  }
  applyParams(params);
  // [ATLAS V41 10/24] Lot-width landing pages preset the width through a page metafield.
  var preset = root && root.getAttribute('data-preset-w');
  if (preset && !params.has('w')) form.elements.w.value = preset;

  function radio(name) { var el = form.querySelector('input[name="' + name + '"]:checked'); return el ? el.value : DEFAULTS[name]; }
  function num(name) {
    var v = parseFloat(form.elements[name].value);
    return isFinite(v) && v >= 0 ? v : null;
  }
  function ftin(x) {
    var neg = x < 0; x = Math.abs(x);
    var ft = Math.floor(x + 1e-6), inch = Math.round((x - ft) * 12);
    if (inch === 12) { ft += 1; inch = 0; }
    return (neg ? '-' : '') + ft + "' " + inch + '"';
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function typeOk(p, t) { return t === 'all' || (t === 'adu' ? p.adu : !p.adu); }
  function siteOk(p, fz, fd) {
    if (fz === 'a' && !p.elev) return false;
    if (fz === 'v' && !p.fds.piling) return false;
    if (fd !== 'any' && !p.fds[fd]) return false;
    return true;
  }
  function check(p, ew, ed, rot) {
    // Straight: plan width faces the street. Turned: plan depth faces the street.
    var res = [];
    var straight = { turned: false, pw: p.w, pd: p.d };
    var turned = { turned: true, pw: p.d, pd: p.w };
    [straight].concat(rot ? [turned] : []).forEach(function (o) {
      var overW = o.pw - ew;
      var overD = ed == null ? 0 : o.pd - ed;
      res.push({ o: o, overW: overW, overD: overD, fits: overW <= 1e-6 && overD <= 1e-6, over: Math.max(overW, overD) });
    });
    // A plan that fits facing the street is shown that way even if turning it leaves more room.
    res.sort(function (a, b) { return (b.fits - a.fits) || (a.fits ? a.o.turned - b.o.turned : a.over - b.over) || (a.o.turned - b.o.turned); });
    return res[0];
  }
  function drawObj(p, r) { return { turned: r.o.turned, pw: r.o.pw, pd: r.o.pd, n: p.n }; }
  function absUrl(u) { return !u ? '' : (u.indexOf('//') === 0 ? 'https:' + u : (u.charAt(0) === '/' ? location.origin + u : u)); }
  function setbackText(L) {
    return 'front ' + ftin(L.f) + ', rear ' + ftin(L.r) + (L.corner ? ', interior side ' + ftin(L.sL) + ', street side ' + ftin(L.sR) : ', each side ' + ftin(L.sL));
  }
  // Modification request link with the lot filled in (read by snippets/modification-request-autofill.liquid).
  function modUrl(p, r) {
    var L = lot, bits = [];
    if (r.overW > 1e-6) bits.push(ftin(r.overW) + ' too wide');
    if (r.overD > 1e-6) bits.push(ftin(r.overD) + ' too deep');
    var txt = 'From the lot fit tool. ' + (L.corner ? 'Corner lot ' : 'Lot ') + ftin(L.W) + ' wide' + (L.D ? ' by ' + ftin(L.D) + ' deep' : '') +
      '. Setbacks: ' + setbackText(L) + '. Buildable area ' + ftin(L.ew) + (L.ed != null ? ' by ' + ftin(L.ed) : ' wide') + '. ' +
      (L.fz !== 'none' || L.fd !== 'any' ? 'Site: ' + [L.fz !== 'none' ? 'flood ' + FZ_NAMES[L.fz] : '', L.fd !== 'any' ? FD_NAMES[L.fd].replace(/^an? /, '') + ' foundation' : ''].filter(Boolean).join(', ') + '. ' : '') +
      p.n + ' is ' + ftin(r.o.pw) + ' by ' + ftin(r.o.pd) + (r.o.turned ? ' turned sideways' : '') + (bits.length ? ', ' + bits.join(' and ') : '') +
      '. Please quote changing it to fit this lot.';
    return '/pages/modification-request?plan=' + encodeURIComponent(p.n) + '&plan_image=' + encodeURIComponent(absUrl(p.i)) +
      '&plan_url=' + encodeURIComponent(absUrl(p.u)) + '&details=' + encodeURIComponent(txt);
  }
  function specList(p) {
    var specs = [];
    if (p.sf) specs.push(Number(p.sf).toLocaleString('en-US') + ' sq ft');
    if (p.bd !== '' && p.bd != null) specs.push(Number(p.bd) === 0 ? 'Studio' : p.bd + ' bed');
    if (p.ba) specs.push(p.ba + ' bath');
    if (p.st) specs.push(p.st + (Number(p.st) === 1 ? ' story' : ' stories'));
    return specs;
  }
  function roomText(r, ew, ed) {
    return ftin((ew - r.o.pw) / 2) + ' to spare each side' + (ed != null ? ', ' + ftin(ed - r.o.pd) + ' front to back' : '');
  }
  function overText(r) {
    var bits = [];
    if (r.overW > 1e-6) bits.push(ftin(r.overW) + ' too wide');
    if (r.overD > 1e-6) bits.push(ftin(r.overD) + ' too deep');
    return bits.join(', ');
  }
  function card(p, r, ew, ed, closeList) {
    var gauge, line;
    if (!closeList) {
      var share = Math.min(100, r.o.pw / ew * 100);
      gauge = '<div class="lf-gauge" aria-hidden="true"><i style="left:' + ((100 - share) / 2).toFixed(2) + '%;width:' + share.toFixed(2) + '%"></i></div>';
      line = '<p class="lf-room">' + roomText(r, ew, ed) + '</p>';
    } else {
      gauge = '<div class="lf-gauge lf-gauge--over" aria-hidden="true"><i></i></div>';
      line = '<p class="lf-over">' + overText(r) + '</p>';
    }
    // No utm on internal links: in GA4 an internal utm starts a new session and wipes the real source.
    return '<a class="lf-card' + (p.h === pickHandle ? ' is-picked' : '') + '" href="' + esc(p.u) + '" data-h="' + esc(p.h) + '">' +
      (p.i ? '<img src="' + esc(p.i) + '" alt="' + esc(p.n) + '" loading="lazy" width="640" height="427">' : '') +
      '<div class="lf-card__b"><h3>' + esc(p.n) + '</h3><p class="lf-specs">' + specList(p).map(function (s) { return '<span>' + esc(s) + '</span>'; }).join('') + '</p>' +
      '<p>Footprint ' + ftin(r.o.pw) + ' wide by ' + ftin(r.o.pd) + ' deep</p>' + gauge + line +
      '<div class="lf-card__foot"><span>From ' + esc(p.pr) + '</span>' + (r.o.turned ? '<span class="lf-tag">Turned sideways</span>' : '') + '</div></div></a>';
  }
  // [ATLAS V39 10/24] "Show on my lot" draws the plan on the site plan without leaving the page.
  // [ATLAS V41 10/24] Compare sits beside it; up to three plans.
  function actions(p) {
    var on = p.h === pickHandle, inCmp = compare.indexOf(p.h) >= 0;
    return '<div class="lf-acts"><button type="button" class="lf-show' + (on ? ' is-on' : '') + '" data-h="' + esc(p.h) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + (on ? 'Shown on your lot' : 'Show on my lot') + '</button>' +
      '<button type="button" class="lf-cmp' + (inCmp ? ' is-on' : '') + '" data-h="' + esc(p.h) + '" aria-pressed="' + (inCmp ? 'true' : 'false') + '">' + (inCmp ? 'In compare' : 'Compare') + '</button></div>';
  }
  function closeCard(p, r, ew, ed) {
    return '<div class="lf-cwrap">' + card(p, r, ew, ed, true) + actions(p) +
      '<a class="lf-quote" href="' + esc(modUrl(p, r)) + '" data-h="' + esc(p.h) + '" data-over="' + r.over.toFixed(1) + '">Get a quote to fit it to this lot</a></div>';
  }

  // Site plan: street at the bottom, front setback measured up from it. On a corner lot the side street runs up the right edge.
  function dimH(x1, x2, y, label, col) {
    var m = (x1 + x2) / 2, tw = label.length * 5.6 + 10;
    return '<g stroke="' + col + '" stroke-width="1"><line x1="' + x1 + '" y1="' + y + '" x2="' + x2 + '" y2="' + y + '"/><line x1="' + x1 + '" y1="' + (y - 4) + '" x2="' + x1 + '" y2="' + (y + 4) + '"/><line x1="' + x2 + '" y1="' + (y - 4) + '" x2="' + x2 + '" y2="' + (y + 4) + '"/></g>' +
      '<rect x="' + (m - tw / 2) + '" y="' + (y - 7) + '" width="' + tw + '" height="14" rx="3" fill="#F6F9F7"/><text x="' + m + '" y="' + (y + 4) + '" text-anchor="middle" font-size="11" fill="' + col + '">' + label + '</text>';
  }
  function dimV(x, y1, y2, label, col) {
    var m = (y1 + y2) / 2, tw = label.length * 5.6 + 10;
    return '<g stroke="' + col + '" stroke-width="1"><line x1="' + x + '" y1="' + y1 + '" x2="' + x + '" y2="' + y2 + '"/><line x1="' + (x - 4) + '" y1="' + y1 + '" x2="' + (x + 4) + '" y2="' + y1 + '"/><line x1="' + (x - 4) + '" y1="' + y2 + '" x2="' + (x + 4) + '" y2="' + y2 + '"/></g>' +
      '<g transform="rotate(-90 ' + x + ' ' + m + ')"><rect x="' + (x - tw / 2) + '" y="' + (m - 7) + '" width="' + tw + '" height="14" rx="3" fill="#F6F9F7"/><text x="' + x + '" y="' + (m + 4) + '" text-anchor="middle" font-size="11" fill="' + col + '">' + label + '</text></g>';
  }
  function svgMarkup(L, plan, uid) {
    var AX = 52, AW = 290, AY = 40, AH = 300, BOT = AY + AH;
    if (!L || !L.W) {
      return '<rect x="' + (AX + 40) + '" y="' + (AY + 30) + '" width="' + (AW - 80) + '" height="' + (AH - 60) + '" fill="none" stroke="#C7D2CB" stroke-width="1.2" stroke-dasharray="5 4" rx="2"/>' +
        '<text x="' + (AX + AW / 2) + '" y="' + (AY + AH / 2) + '" text-anchor="middle" font-size="13" fill="#5E6E68">Enter the lot width to draw it</text>' +
        '<line x1="' + AX + '" y1="' + (BOT + 22) + '" x2="' + (AX + AW) + '" y2="' + (BOT + 22) + '" stroke="#C7D2CB" stroke-width="6" stroke-linecap="round"/>' +
        '<text x="' + (AX + AW / 2) + '" y="' + (BOT + 46) + '" text-anchor="middle" font-size="11" fill="#5E6E68">Street</text>';
    }
    var W = L.W, D = L.D, f = L.f, r = L.r, sL = L.sL, sR = L.sR;
    var ew0 = Math.max(0, W - sL - sR);
    var depth = D || Math.max(W * 1.4, f + r + (plan ? plan.pd : 0) + 6);
    var spanW = Math.max(W, plan ? plan.pw + 2 : 0), spanD = Math.max(depth, plan ? f + plan.pd + 2 : 0);
    var sc = Math.min(AW / spanW, AH / spanD);
    var lw = W * sc, ld = depth * sc, x0 = AX + (AW - lw) / 2, y0 = BOT - ld;
    var bx = x0 + sL * sc, bw = ew0 * sc, by = y0 + r * sc, bh = Math.max(0, ld - (f + r) * sc);
    var g = 'lf-grid-' + uid, hz = 'lf-hatch-' + uid;
    var h = '<defs><pattern id="' + g + '" width="' + (10 * sc) + '" height="' + (10 * sc) + '" patternUnits="userSpaceOnUse" x="' + x0 + '" y="' + BOT + '"><path d="M ' + (10 * sc) + ' 0 L 0 0 0 ' + (10 * sc) + '" fill="none" stroke="#DCE5DF" stroke-width="0.7"/></pattern>' +
      '<pattern id="' + hz + '" width="6" height="6" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><line x1="0" y1="0" x2="0" y2="6" stroke="#1F2C37" stroke-width="1.4" stroke-opacity="0.35"/></pattern></defs>';
    h += '<line x1="' + (x0 - 18) + '" y1="' + (BOT + 22) + '" x2="' + (x0 + lw + (L.corner ? 22 : 18)) + '" y2="' + (BOT + 22) + '" stroke="#C7D2CB" stroke-width="6" stroke-linecap="round"/>';
    h += '<text x="' + (x0 + lw / 2) + '" y="' + (BOT + 46) + '" text-anchor="middle" font-size="11" fill="#5E6E68">Street</text>';
    if (L.corner) {
      var sx = Math.min(x0 + lw + 22, 352);
      h += '<line x1="' + sx + '" y1="' + (y0 - 10) + '" x2="' + sx + '" y2="' + (BOT + 22) + '" stroke="#C7D2CB" stroke-width="6" stroke-linecap="round"/>';
      h += '<text transform="rotate(90 ' + (sx + 12) + ' ' + (y0 + ld / 2) + ')" x="' + (sx + 12) + '" y="' + (y0 + ld / 2) + '" text-anchor="middle" font-size="11" fill="#5E6E68">Side street</text>';
    }
    h += '<rect x="' + x0 + '" y="' + y0 + '" width="' + lw + '" height="' + ld + '" fill="url(#' + g + ')" stroke="#04082e" stroke-width="1.3"' + (D ? '' : ' stroke-dasharray="6 4"') + '/>';
    h += '<rect x="' + bx + '" y="' + by + '" width="' + bw + '" height="' + bh + '" fill="#8DB596" fill-opacity="0.1" stroke="#4F7A5C" stroke-width="1.1" stroke-dasharray="4 3"/>';
    if (plan) {
      var fits = plan.pw <= ew0 + 1e-6 && (!D || plan.pd <= D - f - r + 1e-6);
      var px = bx + (bw - plan.pw * sc) / 2, pyb = BOT - f * sc, pw = plan.pw * sc, ph = plan.pd * sc;
      var col = fits ? '#8DB596' : '#D9905F';
      h += '<rect x="' + px + '" y="' + (pyb - ph) + '" width="' + pw + '" height="' + ph + '" fill="' + col + '" fill-opacity="0.92"/>';
      h += '<rect x="' + px + '" y="' + (pyb - ph) + '" width="' + pw + '" height="' + ph + '" fill="url(#' + hz + ')"/>';
      if (pw > 70 && ph > 34) h += '<text x="' + (px + pw / 2) + '" y="' + (pyb - ph / 2 + 4) + '" text-anchor="middle" font-size="11" font-weight="600" fill="#1F2C37">' + ftin(plan.pw) + ' by ' + ftin(plan.pd) + '</text>';
    }
    h += dimH(x0, x0 + lw, Math.max(12, y0 - 16), ftin(W), '#04082e');
    if (D) h += dimV(Math.max(12, x0 - 18), y0, BOT, ftin(D), '#04082e');
    return h;
  }
  function drawMain(L, plan) {
    var showEl = document.getElementById('lf-showing');
    if (showEl) showEl.textContent = (L && L.W && plan && plan.n) ? 'Drawn: ' + plan.n + ', ' + ftin(plan.pw) + ' by ' + ftin(plan.pd) + (plan.turned ? ', turned sideways' : '') : '';
    document.getElementById('atl-lf-svg').innerHTML = svgMarkup(L, plan, 'm');
  }

  function setTab(next) {
    tab = next;
    document.querySelectorAll('.lf-tab').forEach(function (b) {
      var on = b.getAttribute('data-tab') === tab;
      b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    document.getElementById('atl-lf-fit').hidden = tab !== 'fit';
    document.getElementById('lf-close-wrap').hidden = tab !== 'close';
  }
  function readLot() {
    var W = num('w'), D = num('d'), f = num('f') || 0, r = num('r') || 0, s = num('s') || 0;
    var corner = form.elements.c.checked;
    var ssv = num('ss');
    var sR = corner ? (ssv == null ? s : ssv) : s;
    return { W: W, D: D, f: f, r: r, sL: s, sR: sR, corner: corner, ew: W ? W - s - sR : null, ed: (W && D) ? D - f - r : null, fz: radio('fz'), fd: radio('fd') };
  }

  function buildQuery(withPlan) {
    var q = new URLSearchParams();
    ['w', 'd', 'f', 'r', 's'].forEach(function (k) { var v = form.elements[k].value; if (v !== '') q.set(k, v); });
    if (form.elements.c.checked) { q.set('c', '1'); if (form.elements.ss.value !== '') q.set('ss', form.elements.ss.value); }
    var fz = radio('fz'), fd = radio('fd'), t = form.elements.t.value, o = form.elements.o.value;
    if (fz !== 'none') q.set('fz', fz);
    if (fd !== 'any') q.set('fd', fd);
    if (t !== 'all') q.set('t', t);
    if (o !== 'best') q.set('o', o);
    if (form.elements.rot.checked) q.set('rot', '1');
    if (withPlan) {
      if (pickHandle) q.set('plan', pickHandle);
      if (compare.length) q.set('cmp', compare.join(','));
    }
    return q.toString();
  }

  function render() {
    var L = readLot(), W = L.W, D = L.D, f = L.f, r = L.r;
    var negNote = ['f', 'r', 's', 'ss'].some(function (k) { return parseFloat(form.elements[k].value) < 0; }) ? 'Negative setbacks are counted as 0. ' : '';
    var t = form.elements.t.value, o = form.elements.o.value, rot = form.elements.rot.checked;
    var fz = L.fz, fd = L.fd;
    // The URL is not rewritten while typing: the Google tag counts every history change as a
    // page view (enhanced measurement), which turned each search into an extra page_view.
    // Copy link builds the shareable URL from these inputs instead.
    shareQuery = buildQuery(true);

    var sum = document.getElementById('atl-lf-sum');
    var fitEl = document.getElementById('atl-lf-fit'), closeEl = document.getElementById('atl-lf-close');
    var countEl = document.getElementById('atl-lf-count');
    var pickEl = document.getElementById('atl-lf-pick');
    var baEl = document.getElementById('lf-ba'), nEl = document.getElementById('lf-n');
    var tabFit = document.getElementById('lf-tab-fit'), tabClose = document.getElementById('lf-tab-close');
    var closeTab = document.querySelector('.lf-tab[data-tab="close"]');
    function clearLists(msg) {
      fitEl.innerHTML = ''; closeEl.innerHTML = '';
      tabFit.textContent = '0'; tabClose.textContent = '0'; closeTab.disabled = true; setTab('fit');
      countEl.textContent = msg; nEl.textContent = '0';
      lastFit = []; lastClose = [];
    }
    if (!W) {
      lot = null;
      baEl.textContent = 'Enter a width';
      sum.textContent = negNote;
      clearLists('Enter your lot width to see the plans that fit');
      pickEl.hidden = true;
      drawMain(null);
      lastDraw = [null, null];
      var p0 = pickHandle && byHandle(pickHandle);
      if (p0) {
        pickEl.innerHTML = '<strong>' + esc(p0.n) + '</strong> is ' + ftin(p0.w) + ' wide and ' + ftin(p0.d) + ' deep. With the setbacks above it needs a lot at least ' + ftin(p0.w + L.sL + L.sR) + ' wide and ' + ftin(p0.d + f + r) + ' deep. Enter your lot to check it and see what else fits.';
        pickEl.hidden = false;
      }
      renderCompare();
      return;
    }
    var ew = L.ew, ed = L.ed;
    if (ew <= 0 || (ed != null && ed <= 0)) {
      lot = null;
      baEl.textContent = 'None';
      sum.textContent = negNote + 'The setbacks use up the whole lot. Check the numbers.';
      clearLists('No plans fit these numbers');
      pickEl.hidden = true;
      drawMain(L);
      lastDraw = [L, null];
      renderCompare();
      return;
    }
    lot = L;
    var fit = [], close = [];
    plans.forEach(function (p) {
      if (!typeOk(p, t) || !siteOk(p, fz, fd)) return;
      var res = check(p, ew, ed, rot);
      if (res.fits) fit.push({ p: p, r: res });
      else if (res.over <= CLOSE) close.push({ p: p, r: res });
    });
    // [ATLAS V39 10/24] Sorts per Jeff. Best fit puts the plans that use the most of the
    // buildable width first, then the most of the depth, then the larger house.
    // [ATLAS V41 10/24] With "All plans", Best fit lists houses before garages and ADUs.
    var priceOf = function (x) { return parseFloat(String(x.p.pr || '').replace(/[^0-9.]/g, '')) || 0; };
    fit.sort(function (a, b) {
      if (o === 'small') return a.p.sf - b.p.sf;
      if (o === 'big') return b.p.sf - a.p.sf;
      if (o === 'beds') return ((Number(b.p.bd) || 0) - (Number(a.p.bd) || 0)) || (b.p.sf - a.p.sf);
      if (o === 'price') return (priceOf(a) - priceOf(b)) || (a.p.sf - b.p.sf);
      return (a.p.adu - b.p.adu) || ((ew - a.r.o.pw) - (ew - b.r.o.pw)) || (ed != null ? (ed - a.r.o.pd) - (ed - b.r.o.pd) : 0) || (b.p.sf - a.p.sf);
    });
    close.sort(function (a, b) { return a.r.over - b.r.over; });
    lastFit = fit; lastClose = close;

    baEl.textContent = ftin(ew) + ' by ' + (ed != null ? ftin(ed) : 'any depth');
    nEl.textContent = fit.length;
    sum.textContent = negNote + (D ? '' : 'Add the lot depth to check front to back too.');
    var filtered = fz !== 'none' || fd !== 'any';
    countEl.textContent = fit.length ? fit.length + (fit.length === 1 ? ' plan fits' : ' plans fit') + ' this lot' + (filtered ? ' with these site needs' : '') : 'No plans fit inside these setbacks';
    tabFit.textContent = fit.length; tabClose.textContent = close.length; closeTab.disabled = close.length === 0;
    fitEl.innerHTML = fit.length ? fit.map(function (x) { return '<div class="lf-cwrap">' + card(x.p, x.r, ew, ed, false) + actions(x.p) + '</div>'; }).join('') :
      '<p class="lf-empty">Nothing in the collection fits inside this buildable area' + (filtered ? ' with the flood zone and foundation chosen' : '') + '.' +
      (close.length ? ' ' + close.length + (close.length === 1 ? ' plan comes' : ' plans come') + ' within 3 ft; see the Within 3 ft tab.' : ' None come within 3 ft either. Check the setbacks with your county' + (filtered ? ', try another foundation,' : '') + ' or look at a larger lot.') + '</p>';
    closeEl.innerHTML = close.map(function (x) { return closeCard(x.p, x.r, ew, ed); }).join('');
    if (tab === 'close' && !close.length) setTab('fit'); else setTab(tab);

    var picked = null;
    if (pickHandle) {
      var pp = byHandle(pickHandle);
      if (pp) {
        var pr = check(pp, ew, ed, rot);
        picked = drawObj(pp, pr);
        var needW = pp.w + L.sL + L.sR, needD = pp.d + f + r;
        var siteNote = '';
        if (fz === 'a' && !pp.elev) siteNote = ' It is not an elevated plan, so it is left out for a Zone A lot.';
        else if (fz === 'v' && !pp.fds.piling) siteNote = ' It is not offered on pilings, so it is left out for a Zone V lot.';
        else if (fd !== 'any' && !pp.fds[fd]) siteNote = ' It is not offered on ' + FD_NAMES[fd] + ', so it is left out of the list.';
        pickEl.innerHTML = '<strong>' + esc(pp.n) + '</strong> is ' + ftin(pp.w) + ' wide and ' + ftin(pp.d) + ' deep. With these setbacks it needs a lot at least ' + ftin(needW) + ' wide and ' + ftin(needD) + ' deep. ' +
          (pr.fits ? 'It fits this lot' + (pr.o.turned ? ' turned sideways' : '') + '.' : 'It does not fit this lot: ' + overText(pr) + '.' + (pr.over <= CLOSE ? ' That is close enough to <a class="lf-pick-quote" href="' + esc(modUrl(pp, pr)) + '" data-h="' + esc(pp.h) + '" data-over="' + pr.over.toFixed(1) + '">get a quote to fit it to this lot</a>.' : (fit.length ? ' The plans listed below fit.' : ''))) + siteNote;
        pickEl.hidden = false;
      }
    } else { pickEl.hidden = true; }
    if (!picked && fit.length) picked = drawObj(fit[0].p, fit[0].r);
    lastDraw = [L, picked];
    drawMain(L, picked);
    renderCompare();

    // One search event once the visitor stops typing for 1.5 s, and only when the inputs changed.
    var ev = { lot_width: W, lot_depth: D || 0, buildable_width: Math.round(ew * 10) / 10, flood_zone: FZ_NAMES[fz], foundation: fd, plan_type: t, turned: rot ? 'yes' : 'no', corner: L.corner ? 'yes' : 'no', fit_count: fit.length, close_count: close.length };
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      var key = JSON.stringify([W, D, f, r, L.sL, L.sR, fz, fd, t, rot]);
      if (key === lastSent) return;
      lastSent = key;
      track('lot_fit_search', ev);
      saveRecent(L);
    }, 1500);
  }

  // [ATLAS V41 10/24] Compare up to three plans on the same lot.
  function renderCompare() {
    var el = document.getElementById('lf-compare');
    if (!el) return;
    if (!compare.length) { el.hidden = true; el.innerHTML = ''; return; }
    var L = lot, rot = form.elements.rot.checked;
    var cols = compare.map(function (h, i) {
      var p = byHandle(h), r = L ? check(p, L.ew, L.ed, rot) : null;
      var rows = [
        ['Footprint', ftin(r ? r.o.pw : p.w) + ' by ' + ftin(r ? r.o.pd : p.d) + (r && r.o.turned ? ', turned' : '')],
        ['On this lot', !r ? 'Enter a lot width' : (r.fits ? roomText(r, L.ew, L.ed) : 'Misses: ' + overText(r))],
        ['Size', specList(p).join(', ')],
        ['Foundation included', p.inc.length ? p.inc.join(', ') : (p.fm || 'See the plan')],
        ['Other foundations', p.extra.length ? p.extra.join(', ') + ' (extra)' : 'None listed'],
        ['Price', 'From ' + p.pr]
      ];
      return '<div class="lf-ccol">' +
        (L ? '<svg class="lf-plan lf-plan--sm" viewBox="0 0 360 392" role="img" aria-label="' + esc(p.n) + ' on your lot">' + svgMarkup(L, drawObj(p, r), 'c' + i) + '</svg>' : '') +
        '<div class="lf-ccol__h"><a href="' + esc(p.u) + '" data-h="' + esc(p.h) + '" class="lf-card lf-cname">' + esc(p.n) + '</a><button type="button" class="lf-cx" data-h="' + esc(p.h) + '" aria-label="Remove ' + esc(p.n) + ' from compare">Remove</button></div>' +
        '<dl>' + rows.map(function (rw) { return '<dt>' + rw[0] + '</dt><dd>' + esc(rw[1]) + '</dd>'; }).join('') + '</dl></div>';
    }).join('');
    el.innerHTML = '<div class="lf-compare__head"><h2>Compare on your lot</h2><span>' + (compare.length < 2 ? 'Add one or two more plans with their Compare button.' : compare.length + ' plans') + '</span><button type="button" class="lf-btn" id="lf-cmp-clear">Clear</button></div>' +
      '<div class="lf-compare__cols lf-compare__cols--' + compare.length + '">' + cols + '</div>';
    el.hidden = false;
  }
  function toggleCompare(h) {
    var i = compare.indexOf(h);
    if (i >= 0) compare.splice(i, 1);
    else {
      if (compare.length >= MAXCMP) compare.shift();
      compare.push(h);
      var p = byHandle(h);
      track('lot_fit_compare', { plan_name: p ? p.n : h, compare_count: compare.length });
    }
    render();
  }

  // [ATLAS V41 10/24] Recent lots, kept only in this visitor's browser.
  function readRecent() { try { var a = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function saveRecent(L) {
    if (!L || !L.W) return;
    var q = buildQuery(false);
    var label = (L.D ? L.W + ' by ' + L.D + ' ft' : L.W + ' ft wide') + (L.fz !== 'none' ? ', ' + FZ_NAMES[L.fz] : '') + (L.corner ? ', corner' : '');
    var list = readRecent().filter(function (x) { return x && x.q !== q; });
    list.unshift({ q: q, label: label });
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 4))); } catch (e) {}
    showRecent();
  }
  function showRecent() {
    var el = document.getElementById('lf-recent');
    if (!el) return;
    var current = buildQuery(false);
    var list = readRecent().filter(function (x) { return x && x.q && x.q !== current; }).slice(0, 3);
    if (!list.length) { el.hidden = true; el.innerHTML = ''; return; }
    el.innerHTML = '<span>Recent lots</span>' + list.map(function (x) { return '<button type="button" data-q="' + esc(x.q) + '">' + esc(x.label) + '</button>'; }).join('');
    el.hidden = false;
  }

  // [ATLAS V41 10/24] Address lookup: the US Census geocoder finds the point (JSONP, since it sends no CORS
  // headers; OpenStreetMap is the fallback), FEMA's flood map gives the zone, and USGS elevation around the
  // point gives a rough slope. USGS answers slowly (10 to 20 s), so the flood zone shows first and the slope
  // line is added when it arrives. Nothing is stored and the address is never sent to GA4.
  function getJSON(url, ms) {
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, ms || 9000);
    return fetch(url, ctl ? { signal: ctl.signal } : {}).then(function (res) { clearTimeout(timer); if (!res.ok) throw new Error('http'); return res.json(); });
  }
  function jsonp(url, ms) {
    return new Promise(function (resolve, reject) {
      var cb = '__atlLf' + Math.random().toString(36).slice(2), s = document.createElement('script');
      var done = function () { try { delete window[cb]; } catch (e) { window[cb] = undefined; } if (s.parentNode) s.parentNode.removeChild(s); };
      var timer = setTimeout(function () { done(); reject(new Error('timeout')); }, ms || 9000);
      window[cb] = function (d) { clearTimeout(timer); done(); resolve(d); };
      s.onerror = function () { clearTimeout(timer); done(); reject(new Error('load')); };
      s.src = url + '&callback=' + cb;
      document.head.appendChild(s);
    });
  }
  function geocode(q) {
    return jsonp('https://geocoding.geo.census.gov/geocoder/locations/onelineaddress?benchmark=Public_AR_Current&format=jsonp&address=' + encodeURIComponent(q)).then(function (d) {
      var m = d && d.result && d.result.addressMatches && d.result.addressMatches[0];
      if (!m) throw new Error('none');
      var name = String(m.matchedAddress || q).toLowerCase().replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); }).replace(/, ([A-Za-z]{2}),/, function (x, st) { return ', ' + st.toUpperCase() + ','; });
      return { lat: m.coordinates.y, lon: m.coordinates.x, name: name };
    }).catch(function () {
      return getJSON('https://nominatim.openstreetmap.org/search?format=jsonv2&limit=1&countrycodes=us&q=' + encodeURIComponent(q)).then(function (res) {
        if (!res || !res.length) throw new Error('nf');
        return { lat: parseFloat(res[0].lat), lon: parseFloat(res[0].lon), name: res[0].display_name.split(',').slice(0, 4).join(',') };
      });
    });
  }
  function femaZone(lon, lat) {
    var u = 'https://hazards.fema.gov/arcgis/rest/services/public/NFHL/MapServer/28/query?f=json&geometryType=esriGeometryPoint&inSR=4326&spatialRel=esriSpatialRelIntersects&outFields=FLD_ZONE,ZONE_SUBTY,STATIC_BFE&returnGeometry=false&geometry=' + lon + ',' + lat;
    return getJSON(u, 12000).then(function (j) {
      var feats = (j && j.features) || [];
      if (!feats.length) return { zone: null };
      var best = null, rank = function (z) { return /^V/.test(z) ? 3 : /^A/.test(z) ? 2 : 1; };
      feats.forEach(function (ft) { var a = ft.attributes || {}, z = String(a.FLD_ZONE || '').toUpperCase(); if (!best || rank(z) > rank(best.zone)) best = { zone: z, sub: a.ZONE_SUBTY, bfe: a.STATIC_BFE > -9000 ? a.STATIC_BFE : null }; });
      return best;
    }, function () { return { err: true }; });
  }
  function elevAt(lon, lat) {
    return getJSON('https://epqs.nationalmap.gov/v1/json?units=Feet&wkid=4326&x=' + lon + '&y=' + lat, 30000).then(function (j) {
      var v = parseFloat(j && j.value); return isFinite(v) && v > -1000 ? v : null;
    }, function () { return null; });
  }
  var lookupId = 0;
  function lookup() {
    var input = form.elements.addr, out = document.getElementById('lf-addr-out'), btn = document.getElementById('lf-addr-go');
    var q = (input.value || '').trim();
    if (q.length < 6) { out.textContent = 'Enter a street address with the city and state.'; return; }
    var id = ++lookupId;
    out.textContent = 'Looking up the address…';
    btn.disabled = true;
    geocode(q).then(function (pt) {
      if (id !== lookupId) return;
      var lat = pt.lat, lon = pt.lon;
      return femaZone(lon, lat).then(function (fz) {
        if (id !== lookupId) return;
        site = { name: pt.name, zone: fz.zone, bfe: fz.bfe, ground: null, grade: null, err: fz.err };
        var parts = ['Found: ' + pt.name + '.'];
        var set = null;
        if (fz.err) parts.push('The FEMA flood map did not answer; set the flood zone by hand.');
        else if (!fz.zone) parts.push('No FEMA flood map covers this point.');
        else {
          var z = fz.zone;
          set = /^V/.test(z) ? 'v' : /^A/.test(z) ? 'a' : 'none';
          parts.push('FEMA flood zone ' + z + (fz.bfe != null ? ', base flood elevation ' + fz.bfe + ' ft' : '') + (z === 'X' && fz.sub ? ' (' + String(fz.sub).toLowerCase() + ')' : '') + (z === 'D' ? ' (flood risk not studied here)' : '') + '.');
          if (fz.bfe != null) parts.push('Codes put the lowest floor at or above the base flood elevation, and many counties add 1 to 3 ft.');
        }
        var base = parts.join(' ');
        var tail = ' Read from the address point, not your parcel lines, so your survey is the final word.';
        out.textContent = base + ' Checking the slope…' + tail;
        if (set) { setRadio('fz', set); render(); }
        btn.disabled = false;
        var dLat = 15 / 111320, dLon = 15 / (111320 * Math.cos(lat * Math.PI / 180));
        return Promise.all([elevAt(lon, lat), elevAt(lon, lat + dLat), elevAt(lon, lat - dLat), elevAt(lon + dLon, lat), elevAt(lon - dLon, lat)]).then(function (a) {
          if (id !== lookupId) return;
          var g = a[0], n = a[1], s = a[2], e = a[3], w = a[4], grade = null, extra = '';
          if (n != null && s != null && e != null && w != null) grade = Math.max(Math.abs(n - s), Math.abs(e - w)) / 98.4 * 100;
          site.ground = g; site.grade = grade;
          if (g != null) extra += ' Ground about ' + Math.round(g) + ' ft above sea level.';
          if (grade != null) {
            var gr = Math.round(grade);
            extra += gr < 3 ? ' The ground around the address is close to flat.' :
              gr <= 8 ? ' The ground slopes gently, about ' + gr + ' ft over 100 ft.' :
              ' The ground slopes about ' + gr + ' ft over 100 ft. A crawlspace or a walkout basement usually handles a slope like that.';
          }
          if (!extra) extra = ' The elevation service did not answer, so there is no slope reading.';
          out.textContent = base + extra + tail;
          track('lot_fit_address', { flood_zone: fz.zone || (fz.err ? 'error' : 'unmapped'), slope_band: grade == null ? 'unknown' : grade < 3 ? 'flat' : grade <= 8 ? 'gentle' : 'steep' });
        });
      });
    }).catch(function (e) {
      if (id !== lookupId) return;
      out.textContent = e && e.message === 'nf' ? 'Could not find that address. Check the street number and add the city and state.' : 'The address search did not answer. Try again in a minute, or enter the lot by hand.';
    }).then(function () { if (id === lookupId) btn.disabled = false; });
  }

  // [ATLAS V41 10/24] Lot report: a printable page to save as a PDF or hand to a builder or lender.
  function report() {
    var L = lot, link = location.origin + location.pathname + (shareQuery ? '?' + shareQuery : '');
    var today = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    var css = 'body{font-family:system-ui,-apple-system,"Segoe UI",sans-serif;color:#1F2C37;margin:32px;font-size:13px;line-height:1.45}h1{font-size:22px;margin:0 0 2px;color:#04082e}h2{font-size:15px;margin:22px 0 8px;color:#04082e;border-bottom:1px solid #D3DDD7;padding-bottom:4px}.m{color:#5E6E68}.top{display:flex;gap:24px;align-items:flex-start}.top svg{width:300px;flex:none;border:1px solid #D3DDD7;border-radius:8px;background:#F6F9F7}dl{display:grid;grid-template-columns:auto 1fr;gap:4px 14px;margin:0}dt{color:#5E6E68}dd{margin:0}table{width:100%;border-collapse:collapse}th,td{text-align:left;padding:5px 6px;border-bottom:1px solid #E4EAE6;vertical-align:top}th{font-size:11.5px;color:#5E6E68;font-weight:600}a{color:#04082e}.fine{margin-top:20px;font-size:11px;color:#5E6E68}@media print{body{margin:12mm}a{text-decoration:none}}';
    var h = '<!doctype html><html><head><meta charset="utf-8"><title>Lot report, Intertwine House Plans</title><style>' + css + '</style></head><body>';
    h += '<h1>Lot report</h1><div class="m">Intertwine House Plans, ' + esc(today) + '</div>';
    if (!L) {
      h += '<p>Enter a lot width in the tool first, then print the report.</p>';
    } else {
      var picked = lastDraw && lastDraw[1];
      h += '<div class="top"><svg viewBox="0 0 360 392">' + svgMarkup(L, picked, 'r') + '</svg><dl>' +
        (site ? '<dt>Address</dt><dd>' + esc(site.name) + '</dd>' : '') +
        '<dt>Lot</dt><dd>' + (L.corner ? 'Corner lot, ' : '') + ftin(L.W) + ' wide' + (L.D ? ' by ' + ftin(L.D) + ' deep' : '') + '</dd>' +
        '<dt>Setbacks</dt><dd>' + esc(setbackText(L)) + '</dd>' +
        '<dt>Buildable area</dt><dd>' + ftin(L.ew) + (L.ed != null ? ' by ' + ftin(L.ed) : ' wide, any depth') + '</dd>' +
        '<dt>Flood zone</dt><dd>' + esc(site && site.zone ? 'FEMA ' + site.zone + (site.bfe != null ? ', base flood elevation ' + site.bfe + ' ft' : '') : FZ_NAMES[L.fz]) + '</dd>' +
        (site && site.grade != null ? '<dt>Slope</dt><dd>About ' + Math.round(site.grade) + ' ft over 100 ft near the address point</dd>' : '') +
        '<dt>Foundation</dt><dd>' + (L.fd === 'any' ? 'Any' : FD_SHORT[L.fd]) + '</dd>' +
        (picked ? '<dt>Drawn</dt><dd>' + esc(picked.n) + ', ' + ftin(picked.pw) + ' by ' + ftin(picked.pd) + (picked.turned ? ', turned sideways' : '') + '</dd>' : '') +
        '<dt>Plans that fit</dt><dd>' + lastFit.length + (lastClose.length ? ', plus ' + lastClose.length + ' within 3 ft' : '') + '</dd></dl></div>';
      if (compare.length) {
        h += '<h2>Compared</h2><table><tr><th>Plan</th><th>Footprint</th><th>On this lot</th><th>Size</th><th>Price</th></tr>' + compare.map(function (hh) {
          var p = byHandle(hh), r = check(p, L.ew, L.ed, form.elements.rot.checked);
          return '<tr><td><a href="' + esc(absUrl(p.u)) + '">' + esc(p.n) + '</a></td><td>' + ftin(r.o.pw) + ' by ' + ftin(r.o.pd) + '</td><td>' + esc(r.fits ? roomText(r, L.ew, L.ed) : 'Misses: ' + overText(r)) + '</td><td>' + esc(specList(p).join(', ')) + '</td><td>From ' + esc(p.pr) + '</td></tr>';
        }).join('') + '</table>';
      }
      var rows = function (list, miss) {
        return '<table><tr><th>Plan</th><th>Footprint</th><th>' + (miss ? 'Misses by' : 'Room left') + '</th><th>Size</th><th>Price</th></tr>' + list.map(function (x) {
          return '<tr><td><a href="' + esc(absUrl(x.p.u)) + '">' + esc(x.p.n) + '</a></td><td>' + ftin(x.r.o.pw) + ' by ' + ftin(x.r.o.pd) + (x.r.o.turned ? ', turned' : '') + '</td><td>' + esc(miss ? overText(x.r) : roomText(x.r, L.ew, L.ed)) + '</td><td>' + esc(specList(x.p).join(', ')) + '</td><td>From ' + esc(x.p.pr) + '</td></tr>';
        }).join('') + '</table>';
      };
      if (lastFit.length) h += '<h2>Plans that fit (' + lastFit.length + ')</h2>' + rows(lastFit, false);
      if (lastClose.length) h += '<h2>Within 3 ft, a modification Angela can quote (' + lastClose.length + ')</h2>' + rows(lastClose, true);
    }
    h += '<p class="fine">Footprints are the overall width and depth as drawn, porches and decks included. Setbacks are measured from the property lines. Flood zone rules, base flood elevation, easements, height limits, lot coverage and HOA rules can also apply, so confirm with your planning office and engineer before you buy. Flood zone from FEMA\'s National Flood Hazard Layer and elevation from USGS when an address was looked up. Open this lot again: <a href="' + esc(link) + '">' + esc(link) + '</a></p>';
    h += '</body></html>';
    track('lot_fit_report', { fit_count: lastFit.length, compare_count: compare.length });
    var win = null;
    try { win = window.open('', '_blank'); } catch (e) {}
    if (win && win.document) {
      win.document.open(); win.document.write(h); win.document.close();
      setTimeout(function () { try { win.focus(); win.print(); } catch (e) {} }, 400);
    } else {
      var blob = new Blob([h], { type: 'text/html' });
      location.href = URL.createObjectURL(blob);
    }
  }

  form.addEventListener('input', function (e) { if (e.target && e.target.name === 'addr') return; if (e.target && e.target.name === 'c') syncCorner(); render(); });
  form.addEventListener('change', function (e) { if (e.target && e.target.name === 'addr') return; if (e.target && e.target.name === 'c') syncCorner(); render(); });
  form.addEventListener('submit', function (e) { e.preventDefault(); });
  form.elements.addr.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); lookup(); } });
  document.getElementById('lf-addr-go').addEventListener('click', lookup);
  document.querySelectorAll('.lf-tab').forEach(function (b) {
    b.addEventListener('click', function () { if (!b.disabled) setTab(b.getAttribute('data-tab')); });
  });
  document.getElementById('lf-reset').addEventListener('click', function () {
    ['w', 'd', 'f', 'r', 's', 'ss', 't', 'o'].forEach(function (k) { form.elements[k].value = DEFAULTS[k]; });
    setRadio('fz', 'none'); setRadio('fd', 'any'); form.elements.rot.checked = false; form.elements.c.checked = false; syncCorner();
    pickHandle = null; compare = []; site = null; lookupId++; document.getElementById('lf-addr-go').disabled = false;
    form.elements.addr.value = ''; document.getElementById('lf-addr-out').textContent = document.getElementById('lf-addr-out').getAttribute('data-default') || '';
    render(); showRecent();
  });
  document.getElementById('lf-copy').addEventListener('click', function () {
    var b = this, url = location.origin + location.pathname + (shareQuery ? '?' + shareQuery : '');
    var done = function () { b.textContent = 'Link copied'; setTimeout(function () { b.textContent = 'Copy link'; }, 1800); };
    try { navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link', url); }); } catch (e) { window.prompt('Copy this link', url); }
  });
  document.getElementById('lf-print').addEventListener('click', report);
  document.getElementById('lf-recent').addEventListener('click', function (e) {
    var b = e.target.closest('button[data-q]'); if (!b) return;
    var keepPlan = pickHandle, keepCmp = compare.slice();
    applyParams(new URLSearchParams(b.getAttribute('data-q')));
    pickHandle = keepPlan; compare = keepCmp;
    render(); showRecent();
  });
  function hoverDraw(e) {
    var c = e.target.closest('.lf-card'); if (!c || c.classList.contains('lf-cname')) return;
    var p = byHandle(c.getAttribute('data-h')); if (!p || !lot) return;
    drawMain(lot, drawObj(p, check(p, lot.ew, lot.ed, form.elements.rot.checked)));
  }
  function hoverOut() { if (lastDraw) drawMain(lastDraw[0], lastDraw[1]); }
  function resultsClick(e) {
    var cmpB = e.target.closest('.lf-cmp, .lf-cx');
    if (cmpB) { toggleCompare(cmpB.getAttribute('data-h')); return; }
    if (e.target.closest('#lf-cmp-clear')) { compare = []; render(); return; }
    var b = e.target.closest('.lf-show'); if (!b) return;
    var h = b.getAttribute('data-h'), p = byHandle(h); if (!p) return;
    pickHandle = h;
    render();
    var st = document.querySelector('.lf-stage');
    if (st) {
      var top = st.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.5) {
        var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        st.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
      }
    }
    track('lot_fit_show', { plan_name: p.n, lot_width: lot ? lot.W : 0 });
  }
  function clickTrack(e) {
    var a = e.target.closest('a'); if (!a) return;
    var h = a.getAttribute('data-h'), p = h && byHandle(h);
    if (!p) return;
    if (a.classList.contains('lf-quote') || a.classList.contains('lf-pick-quote')) {
      track('lot_fit_quote', { plan_name: p.n, miss_ft: parseFloat(a.getAttribute('data-over')) || 0, lot_width: lot ? lot.W : 0 });
    } else if (a.classList.contains('lf-card')) {
      var inClose = !!a.closest('#atl-lf-close');
      track('select_item', { item_list_id: 'lot_fit', item_list_name: a.closest('#lf-compare') ? 'Lot fit, compare' : (inClose ? 'Lot fit, within 3 ft' : 'Lot fit, fits'), items: [{ item_id: p.h, item_name: p.n }] });
    }
  }
  ['atl-lf-fit', 'atl-lf-close', 'atl-lf-pick', 'lf-compare'].forEach(function (id) { document.getElementById(id).addEventListener('click', clickTrack); });
  ['atl-lf-fit', 'atl-lf-close', 'lf-compare'].forEach(function (id) { document.getElementById(id).addEventListener('click', resultsClick); });
  ['atl-lf-fit', 'atl-lf-close'].forEach(function (id) {
    var el = document.getElementById(id);
    el.addEventListener('mouseover', hoverDraw);
    el.addEventListener('mouseleave', hoverOut);
  });
  render();
  showRecent();
})();
